import { tokenService } from "sbtech-sports-data-api-client";
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
/**
 * Global configuration for SportDataApi/BFF
 */
export class GlobalConfigs {
    constructor(config) {
        this.apiConfigs = config.apiConfigs;
        this.authorization = config.authorization;
        this.isDebug = config.isDebug;
    }
    setAuthorization(authorization) {
        this.authorization = authorization;
        tokenService.apiAccessToken = authorization.token;
    }
    getAuthorization() {
        return this.authorization;
    }
}
export var GlobalConfig = new GlobalConfigs({
    apiConfigs: {
        sportDataApiUrl: "",
        bffApiUrl: "",
        locale: "",
        betsApiUrl: ""
    },
    authorization: {
        token: ""
    },
    isDebug: false
});
/**
 * init function initialize GlobalConfig object
 * @param config {GlobalConfig} config object to override the default values
 */
export const init = (config) => {
    !Object.isFrozen(GlobalConfig.apiConfigs)
        && (GlobalConfig.apiConfigs = Object.assign(Object.assign({}, GlobalConfig.apiConfigs), config.apiConfigs))
        && Object.freeze(GlobalConfig.apiConfigs);
    GlobalConfig.isDebug = config.isDebug;
    GlobalConfig.setAuthorization(Object.assign(Object.assign({}, GlobalConfig.getAuthorization()), config.authorization));
    internalMessageBus.on(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken, (msg) => {
        msg.data[0] && msg.data[0].token && GlobalConfig.setAuthorization(msg.data[0]);
    });
};
//# sourceMappingURL=init.js.map